export default __webpack_public_path__ + "static/media/080_finish_bad.av1.cab9cc3e.mp4";